import { CustomerCard } from 'containers/customers/customers.model';
import { PaymentMode } from 'containers/settings/invoiceSettings.model';
import { CARD_ON_FILE_MESSAGES, MANUAL_KEY_IN_MESSAGES } from '../constants';
import { ChargeCustomerCardErrorStatusResponse } from 'containers/app/app.model';

interface ErrorHandlerParams {
  error: any;
  cardData: CustomerCard;
  getChargeCardErrorStatus: any;
  teamId: number;
}

interface FeatureStatusCheckResult {
  isEnabled: boolean;
  message?: string;
}

export const handleChargeCardError = async ({
  error,
  cardData,
  getChargeCardErrorStatus,
  teamId
}: ErrorHandlerParams) => {
  try {
    if (error?.data) {
      const errorStatus: ChargeCustomerCardErrorStatusResponse = await getChargeCardErrorStatus({
        teamId,
        transactionId: error.data.details || '',
        errorCode: error.data.message || ''
      }).unwrap();
      return {
        cardData,
        message: errorStatus.title,
        subtitle: errorStatus.subtitle,
        txnId: error.data.details || '',
        canRetry: errorStatus.canRetry
      };
    }

    // If error status API fails or other errors
    return {
      cardData,
      message: 'An error occurred while charging the card.',
      txnId: '',
      canRetry: true
    };
  } catch (errorStatusError) {
    return {
      cardData,
      message: 'An error occurred while charging the card.',
      txnId: '',
      canRetry: true
    };
  }
};

export const checkFeatureStatus = (
  paymentMode: PaymentMode,
  isOwner: boolean,
  isAdmin: boolean,
  featureType: 'cardOnFile' | 'manualKeyIn'
): FeatureStatusCheckResult => {
  if (!paymentMode) {
    return { isEnabled: false };
  }

  const messages = featureType === 'cardOnFile' ? CARD_ON_FILE_MESSAGES : MANUAL_KEY_IN_MESSAGES;

  if (!paymentMode.adminEnabled) {
    return {
      isEnabled: false,
      message: messages.NOT_ADMIN_ENABLED
    };
  }

  if (!paymentMode.enabled) {
    return {
      isEnabled: false,
      message: isOwner || isAdmin ? messages.TEAM_OWNER_ADMIN : messages.TEAM_MEMBER
    };
  }

  return { isEnabled: true };
};
